import { ContentfulEntry } from '../../contentful/models/types';
import { ContentfulFeatureToggle } from '../types';
import { FeatureToggleStrategy } from '../strategies/FeatureToggleStrategy';
import { DefaultToggleStrategy } from '../strategies/DefaultToggleStrategy';

export class FeatureToggle<
  Toggle,
  ReturnValue = Toggle,
> implements ContentfulEntry {
  public readonly referencedBy: string[] = [];
  public readonly slug: string = '';
  private readonly strategy: FeatureToggleStrategy<ReturnValue>;

  constructor(
    private readonly data?: ContentfulFeatureToggle<Toggle>,
    strategy?: FeatureToggleStrategy<ReturnValue>,
  ) {
    this.strategy = strategy ?? new DefaultToggleStrategy();
  }

  public get id() {
    return this.data?.sys?.id;
  }

  public getKey(): string {
    return this.data?.fields?.hybridFeatureToggle_key ?? '';
  }

  public overridesDefaultValue(): boolean {
    return this.data?.fields?.hybridFeatureToggle_enabled ?? false;
  }

  public getValue(): ReturnValue {
    return this.strategy.determineToggleValue(
      this.data?.fields?.hybridFeatureToggle_value,
    );
  }

  public isValidToggle(): boolean {
    return this.strategy.isValidToggle(
      this.data?.fields?.hybridFeatureToggle_value,
    );
  }

  public getIdentifier(): string {
    return this.id;
  }
}
